<template>
  <div class="main-hd">
    <div class="x-nav">当前所在位置 : {{ postionStr }}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      postionStr: "",
    };
  },
  props: {
    nav: {
      type: String,
      default: "",
    },
  },
  mounted() {
    console.log(this.$route.meta);
    this.postionStr = this.$route.meta.menu_name;
  },
};
</script>
<style scoped lang="scss">
@import "src/assets/sass/mixin";
/*所在位置*/
.x-nav {
  color: #888;
  padding: 20px 30px;
  vertical-align: middle;
  position: relative;
}
.x-nav a {
  color: #888;
  display: inline-block;
}
.x-nav span {
  color: #333;
  display: inline-block;
}
.x-nav i {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-left: 1px solid #999;
  border-bottom: 1px solid #999;
  -webkit-transform: translate(0, -50%) rotate(-135deg);
  transform: translate(0, -50%) rotate(-135deg);
  vertical-align: -3px;
  margin-left: 3px;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/master/master-head-position.vue